import get from "lodash/get";
import { stringUtils } from "conversional-utils";
export var isNode = function (component) { return get(component, 'Content.type') || get(component, 'Children'); };
export var generateComponentKey = function (path, alternativeComponentIdentifier) {
    if (alternativeComponentIdentifier === void 0) { alternativeComponentIdentifier = ""; }
    if (!path || typeof path !== 'string') {
        // Ensure generated random string only has safe characters
        var safeRandomString = stringUtils.randomString(8)
            .replace(/[^a-zA-Z0-9-_]/g, '') // Only allow alphanumeric, hyphen, underscore
            .trim();
        return "".concat(alternativeComponentIdentifier, "_").concat(safeRandomString)
            .replace(/[ \/]/g, '_'); // Replace spaces and slashes with underscores
    }
    return path.trim().replace(/[^a-zA-Z0-9-_]/g, "_");
};
